import { CellValueChangedEvent, ColDef } from '@ag-grid-community/core';
import { Observable, of, tap } from 'rxjs';
import {
  IStockMovementLinesEditorComponent,
  IStockMovementService,
  StockLinePolicy,
} from './stock-doc-movement-line.policy';
import { DocLineUpdatedDto, StockDocDto } from '@digiwall/goliath-documents/proxy';
import { Rest } from '@abp/ng.core';
import { ArticleSerialLookupRequestDto } from '@digiwall/goliath-products/proxy';
import StockDocLinesEditorComponent from '../../../../stock-doc-lines-editor.component';
import { BaseDocServiceForLineEditor } from '../../../../../../components/lines-editor/base-doc-line-editor/base-doc-line-editor';

export class StockDocWithdrawalMovementPolicy<
  T extends StockDocLinesEditorComponent<TDoc, TService> & IStockMovementLinesEditorComponent,
  TDoc extends StockDocDto,
  TService extends BaseDocServiceForLineEditor & IStockMovementService,
> implements StockLinePolicy
{
  constructor(private ctx: T) {}

  get addPurchaseData() {
    return false;
  }

  enhanceColDefs(colDefs: ColDef[]): ColDef[] {
    colDefs.find(x => x.field === 'quantity').hide = true;
    colDefs.find(x => x.field === 'articleSerialId').editable = params => params.data.articleId;
    colDefs.find(x => x.field === 'unitPrice').editable = false;
    colDefs.find(x => x.field === 'stockLocationId').editable = false;

    const serialField = colDefs.find(x => x.field === 'articleSerialId');

    serialField.cellEditorParams.callback = (lineId: string, id: string, item: any) => {
      this.ctx.stockDocService
        .selectSerialWithdrawal(this.ctx.document.id, lineId, item.serialNumber)
        .subscribeOnce(res => {
          if (res) {
            this.ctx.updateLines(res);
          }
        });
    };
    serialField.cellEditorParams.values$ = (currentLine: any) => {
      return (dto: ArticleSerialLookupRequestDto) => {
        dto.articleId = currentLine.articleId;
        dto.onlyStocked = true;
        dto.onlyActive = true;
        dto.queryProperties = ['serialNumber'];
        dto.sorting = [{ property: 'serialNumber' }];
        return this.ctx.stockArticleSerialService.getSerials(dto);
      };
    };

    return colDefs;
  }

  onCellValueChanged(event: CellValueChangedEvent): Observable<any> | boolean {
    switch (event.column.getColId()) {
      case 'code':
        return this.ctx.stockDocService
          .selectSerialWithdrawal(this.ctx.document.id, event.data.id, event.newValue)
          .pipe(
            tap(res => {
              if (res) {
                this.ctx.updateLines(res);
              }
            }),
          );
      default:
        return false;
    }
  }

  getAddArticleLineFn(): (
    docId: string,
    order: number,
    lineFromId: string,
    config?: Partial<Rest.Config>,
  ) => Observable<DocLineUpdatedDto> {
    return this.ctx.stockDocService.addWithdrawalArticleLine;
  }

  beforeAddArticleLine(): Observable<DocLineUpdatedDto | null> {
    return of(null);
  }

  beforeSaveDoc(): Observable<DocLineUpdatedDto | null> {
    return of(null);
  }

  onLineAdded() {}

  beforeSaveLine(): void {}

  onUnsavedLineChanged(response: DocLineUpdatedDto): DocLineUpdatedDto {
    return response;
  }

  focusOnNewLine() {
    return true;
  }
}
